"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ShieldCheck } from "lucide-react";
export default function SecurityNotice() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="w-full bg-light-background py-6">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className={`flex items-start gap-3 transition-all duration-[150ms] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <ShieldCheck className="size-5 text-secondary shrink-0 mt-0.5" aria-hidden="true" />
          <p className="text-sm text-foreground-light leading-relaxed">
            Your security and privacy are our top priorities. All information
            submitted through our forms is transmitted securely using industry-standard
            encryption protocols. We do not share your personal data with third
            parties without your explicit consent. For more details, please review
            our Privacy Policy and Terms of Service.
          </p>
        </div>
      </div>
    </section>;
}